import * as React from 'react'
import { TaskStatusListConnected } from './TaskStatusListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskStatusListExamples = () => {
  return (
    <div className="TaskStatusListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskStatusListConnected />
      </Provider>
    </div>
  )
}
